export { PRODUCT_DOMAINS, TITLE_MAP, getTitle } from './routesTools';
